import { render } from "./ArchiveAlbumDetailView.vue?vue&type=template&id=5e5a7352"
import script from "./ArchiveAlbumDetailView.vue?vue&type=script&lang=js"
export * from "./ArchiveAlbumDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__